import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../../models/dtos/error.dto';
import getFleetUTTSListRepository, {
  ServiceResponse,
} from './getFleetUTTSList.repository';
import { Errors } from '../../../errors';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getFleetUTTSList = createAsyncThunk(
  'getFleetUTTSList',
  async (): Promise<ServiceResponse[]> => {
    return await getFleetUTTSListRepository().catch((error: any) => {
      throw error;
    });
  }
);

const serviceSlice = createSlice({
  name: 'fleetUtts',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFleetUTTSList.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getFleetUTTSList.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getFleetUTTSList.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
